function toggleText(button) {
  const content = button.previousElementSibling;
  if (!content) return;

  requestAnimationFrame(function () {
    const isExpanded = content.classList.toggle('expanded');
    content.classList.toggle('line-clamp');
    button.textContent = isExpanded ? 'Ler menos' : 'Ler mais';
    button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.expandable-text-section .toggle-button').forEach(function (button) {
    button.addEventListener('click', function () {
      toggleText(button);
    }, { passive: true });
  });
});
